// Išsaugotos vietos — laikomos localStorage (iki paskyros Bloke 5).
// Saugom pilnus vietų objektus, kad sąrašą galėtume atvaizduoti be DB.

const RAKTAS = 'issaugotos_vietos'

export function getIssaugotos() {
  try {
    const raw = localStorage.getItem(RAKTAS)
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

export function arIssaugota(id) {
  return getIssaugotos().some(v => v.id === id)
}

// Perjungia vietos išsaugojimą. Grąžina naują būseną (true = išsaugota).
export function perjungtiIssaugota(vieta) {
  const sarasas = getIssaugotos()
  const yra = sarasas.some(v => v.id === vieta.id)
  const naujas = yra
    ? sarasas.filter(v => v.id !== vieta.id)
    : [...sarasas, vieta]
  try {
    localStorage.setItem(RAKTAS, JSON.stringify(naujas))
  } catch {
    // localStorage nepasiekiamas — tyliai praleidžiam
  }
  return !yra
}
